var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Bfhs'),_c('RecentlyPlayedMixes'),_c('MadeForYou'),_c('FeaturedPlaylists'),_c('FeaturedCharts'),_c('LatestMixes'),_c('ChartBox'),_c('TrendingMixes'),_c('HomeRadio'),_c('TrendingDjs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }